import axios from '../axios';

export const show = (lang) => {
  return axios.get(`/general-terms-of-sale?lang=${lang}`);
};

export const submit = (payload) => {
  return axios.post('/general-terms-of-sale', payload);
};
